<div class="main-container">
    <br><br>
    <div class="carousel-container">
        <div id="compressorCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/slides img/screw-air-compressor.jpeg" style="border-radius: 15px; box-shadow: 10px;"  height="50%" width="50%">
                </div>
            </div>
            <a class="carousel-control-prev" href="#compressorCarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#compressorCarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>

    <!-- Contact Information Section (Second Section) -->
    <div class="contact-info">
        <a href="tel:8489359948" class="contact-btn phone-btn">
            <span class="fa fa-phone"></span> Call Now
        </a>
        <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn">
            <span class="fa fa-envelope"></span> Email Us
        </a>
        <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn">
            <span class="fa fa-whatsapp"></span>WhatsApp
        </a>
    </div>

    <!-- Multi Brand Piston Compressor Title and Tagline (Third Section) -->
    <div class="header">
        <h1 class="title">SCREW AIR COMPRESSOR</h1>
        <p class="tagline">Efficient, Reliable, and Long-lasting Compressor Solutions</p>
        <p class="tagline1">
           <li> A screw air compressor is a type of positive displacement compressor that utilizes a pair of helical screws to compress air.</li>
        </p>
        <p class="tagline1">
           <li> It is known for its high efficiency and ability to provide continuous, reliable airflow.</li>
        </p>
        <p class="tagline1">
            <li>Unlike piston compressors, screw compressors operate with less vibration and noise, making them ideal for environments where quieter operations are essential.</li>
        </p>
        <p class="tagline1">
            <li>They are commonly used in industrial applications such as manufacturing, automotive, and energy production.</li>
        </p>
        <p class="tagline1">
           <li> Screw air compressors offer advantages like lower maintenance costs, longer service life, and more energy-efficient performance, especially in 
            continuous-duty operations.</li>
        </p>
        <p class="tagline1">
           <li> Additionally, they can handle varying air demands and provide consistent pressure, making them a valuable asset for industries
             requiring reliable compressed air.</li>
        </p>
        
    </div>

    <!-- Feature Highlights Section (Last Section) -->
    <div class="feature-highlights">
        <div class="feature-card">
            <i class="fa fa-cogs"></i>
            <h4 class="font-weight-bold">Quick Response</h4>
            <p>We respond quickly to minimize downtime.</p>
        </div>
        <div class="feature-card">
            <i class="fa-check-circle"></i>
            <h4 class="font-weight-bold">Affordable Pricing</h4>
            <p>Get clear estimates upfront with no hidden fees.</p>
        </div>
        <div class="feature-card">
            <i class="fa fa-check-circle"></i>
            <h4 class="font-weight-bold">Genuine Parts</h4>
            <p>We only use OEM parts for reliability.</p>
        </div>
    </div>
    <!-- <div>
        <ul>
            <p>
                
            </p>
        </ul>
    </div> -->

</div>
